module.exports = __webpack_public_path__ + "static/media/Poppins-Thin.b03c3b98.woff2";